// extracted by mini-css-extract-plugin
module.exports = {"skillCard":"SkillCard_skillCard__24EFS","iconContainer":"SkillCard_iconContainer__3EisB","skillIcon":"SkillCard_skillIcon__1Cz5Y","skillLabel":"SkillCard_skillLabel__262NO"};